
   $( document ).ready(function() {
            
            function VariantChanged(){
              // hide unavailable variants
              // $('.variant-input-wrap[name="Strength"] .variant__button-label, .variant-input-wrap[name="Size"] .variant__button-label').removeClass('disabled');
              // $('.variant-input-wrap[name="Flavor"] .variant-input input[type="radio"].disabled').closest('.variant-input').css('display', 'none');
              // $('.variant-input-wrap[name="Flavor"] .variant-input input[type="radio"]:not(.disabled)').closest('.variant-input').css('display', 'inline-block');


              // Faq
                var activeVariant = $('select[name="id"]').val();
                var faqWrap = $('.FAQ-wrap[data-id="'+activeVariant+'"]');

                $('.variant-info, .FAQ-wrap').hide().removeClass('active');


                $('.variant-info[data-id="'+activeVariant+'"]').fadeIn().addClass('active');

                if ( faqWrap.hasClass('no-faq')) {
                    faqWrap.hide().removeClass('active');
                    $('.Faq--section').hide();
                } else {
                    faqWrap.fadeIn().addClass('active');
                    $('.Faq--section').show();
                }
            }


            $('.variant-input').on('change', function(){
                console.log('tested');
                VariantChanged();
            });

            VariantChanged();

            $(".Product__accordion_head").click(function() {
              if ($('.Product__accordion_body').is(':visible')) {
                $(".Product__accordion_body").slideUp(300);
                $(".plusminus").text('+'); 
              }
              if ($(this).next(".Product__accordion_body").is(':visible')) {
                $(this).next(".Product__accordion_body").slideUp(300);
                $(this).children(".plusminus").text('+');
              } else {
                $(this).next(".Product__accordion_body").slideDown(300);
                $(this).children(".plusminus").text('-');
              }
            });

            // $(window).scroll(function(e){ 
            //   var $el = $('.product__photos'); 
            //   var isPositionFixed = ($el.css('position') == 'fixed');
            //   if ($(this).scrollTop() > 200 && !isPositionFixed){ 
            //     $el.css({'position': 'fixed', 'top': '0px'}); 
            //   }
            //   if ($(this).scrollTop() < 200 && isPositionFixed){
            //     $el.css({'position': 'static', 'top': '0px'}); 
            //   } 
            // });
            var Tabs = $('.PageTabs--Head--item');
            Tabs.on('click', function(){
              var $self = $(this),
                  Tab = $self.data('tab-id'),
                  $tabBody = $('#' + Tab);
          
              Tabs.removeClass('active');
              $self.addClass('active');
          
              $('.PageTabs--Body--item').removeClass('active').hide();
              $tabBody.addClass('active').show();
            });
    });
 
/* Function -> Flavor filter (added 2026-10-20). Runs only on products with "Function" + "Flavor" options
   (e.g. Melting Forest Sparkling Water). Shows only the flavors of the chosen function and
   auto-selects the first flavor when the function changes, so shoppers never hit "Unavailable". */
(function () {
  function initFnFlavor() {
    var fnWrap = document.querySelector('fieldset.variant-input-wrap[name="Function"]');
    var flWrap = document.querySelector('fieldset.variant-input-wrap[name="Flavor"]');
    var sel = document.querySelector('select[name="id"]');
    if (!fnWrap || !flWrap || !sel || fnWrap.dataset.fnflavor) return;
    fnWrap.dataset.fnflavor = '1';
    var map = {};
    Array.prototype.forEach.call(sel.options, function (o) {
      var m = o.textContent.trim().match(/^(.+?)\s\/\s(.+?)\s+-\s/);
      if (!m) return;
      (map[m[1].trim()] = map[m[1].trim()] || []).push(m[2].trim());
    });
    function apply(autoPick) {
      var fnInput = fnWrap.querySelector('input:checked');
      if (!fnInput || !map[fnInput.value]) return;
      var allowed = map[fnInput.value];
      var firstLabel = null, currentOk = false;
      flWrap.querySelectorAll('.variant-input').forEach(function (box) {
        var ok = allowed.indexOf(box.getAttribute('data-value')) !== -1;
        box.style.display = ok ? '' : 'none';
        var inp = box.querySelector('input');
        if (ok && !firstLabel) firstLabel = box.querySelector('label');
        if (ok && inp && inp.checked) currentOk = true;
      });
      if (autoPick && !currentOk && firstLabel) firstLabel.click();
    }
    // Every function always has flavors, so never cross out a Function button
    function unstrike() {
      fnWrap.querySelectorAll('input.disabled, label.disabled').forEach(function (el) {
        var v = el.tagName === 'INPUT' ? el.value : (el.previousElementSibling && el.previousElementSibling.value);
        if (v && map[v]) el.classList.remove('disabled');
      });
    }
    new MutationObserver(unstrike).observe(fnWrap, { subtree: true, attributes: true, attributeFilter: ['class'] });
    unstrike();
    fnWrap.addEventListener('change', function () { setTimeout(function () { apply(true); }, 0); });
    apply(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFnFlavor);
  else initFnFlavor();
})();
